function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
import React from "react";
import PropTypes from "prop-types";
import Circle from "../../project/circle";
import { onResize, WDHImage } from "@demant/wdh";
import Nudge from "./nudge";
import { WDHGDPR } from "@demant/wdh-gdpr";
var DemantIntroBannerHero = /*#__PURE__*/function (_React$Component) {
  function DemantIntroBannerHero(props) {
    var _this;
    _classCallCheck(this, DemantIntroBannerHero);
    _this = _callSuper(this, DemantIntroBannerHero, [props]);
    _this.state = {
      isDesktop: _this.resolveDesktop(),
      circleClassName: "",
      consent: WDHGDPR.permissionGiven()
    };
    if (!_this.state.consent) {
      WDHGDPR.listenForConsent(function () {
        _this.setState({
          consent: true
        });
      });
    }
    return _this;
  }
  _inherits(DemantIntroBannerHero, _React$Component);
  return _createClass(DemantIntroBannerHero, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;
      onResize(function () {
        _this2.updateDesktopState();
        _this2.calculateCircleStyles();
      });
    }
  }, {
    key: "calculateCircleStyles",
    value: function calculateCircleStyles() {
      var prop = this.props.$component.height() / this.props.$component.width();
      this.props.$component.attr("data-props", prop);
      if (prop < 0.4) {
        var circleClassName = "fixed-bottom";
        this.setState({
          circleClassName: circleClassName
        });
      }
    }
  }, {
    key: "updateDesktopState",
    value: function updateDesktopState() {
      this.setState({
        isDesktop: this.resolveDesktop()
      });
    }
  }, {
    key: "resolveDesktop",
    value: function resolveDesktop() {
      return window.matchMedia("(min-width:992px)").matches;
    }
  }, {
    key: "render",
    value: function render() {
      var showVideo = this.state.consent && !!this.props.externalVideo;
      var _this$props$mobileIma = this.props.mobileImageData,
        mobileImagesSrc = _this$props$mobileIma.mobileImagesSrc,
        mobileImageWidth = _this$props$mobileIma.mobileImageWidth,
        mobileImageHeight = _this$props$mobileIma.mobileImageHeight,
        mobileImageAlt = _this$props$mobileIma.mobileImageAlt;
      return /*#__PURE__*/React.createElement(React.Fragment, null, showVideo && /*#__PURE__*/React.createElement("div", {
        className: "banner-video",
        style: this.props.externalVideoStyle,
        dangerouslySetInnerHTML: {
          __html: this.props.externalVideo
        }
      }), this.props.circleSpot && /*#__PURE__*/React.createElement(Circle, {
        className: this.state.circleClassName
      }), !showVideo && (this.state.isDesktop || !this.state.isDesktop && !mobileImagesSrc) && /*#__PURE__*/React.createElement(WDHImage, {
        image: this.props.desktopImage
      }), !showVideo && !this.state.isDesktop && !!mobileImagesSrc && /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("img", {
        src: mobileImagesSrc,
        width: mobileImageWidth,
        height: mobileImageHeight,
        alt: mobileImageAlt
      })), /*#__PURE__*/React.createElement("div", {
        className: "banner-container"
      }, /*#__PURE__*/React.createElement("div", {
        className: "banner-container-inner"
      }, /*#__PURE__*/React.createElement("div", {
        className: "banner-content",
        dangerouslySetInnerHTML: {
          __html: this.props.bannerContent
        }
      }))), this.state.isDesktop && this.props.addNudge && /*#__PURE__*/React.createElement(Nudge, null));
    }
  }]);
}(React.Component);
DemantIntroBannerHero.propTypes = {
  desktopImage: PropTypes.instanceOf(HTMLImageElement).isRequired,
  $component: PropTypes.instanceOf(jQuery).isRequired,
  mobileImageSrc: PropTypes.string,
  mobileImageData: PropTypes.object,
  bannerContent: PropTypes.string,
  externalVideo: PropTypes.string,
  externalVideoStyle: PropTypes.object,
  // eslint-disable-line react/forbid-prop-types
  circleSpot: PropTypes.bool.isRequired,
  addNudge: PropTypes.bool
};
DemantIntroBannerHero.defaultProps = {
  externalVideo: "",
  externalVideoStyle: {},
  bannerContent: "",
  mobileImageData: {},
  mobileImageSrc: "",
  addNudge: false
};
export default DemantIntroBannerHero;